import { Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterLink } from '@angular/router';
import { filter, map, startWith } from 'rxjs';
import { LoginService } from '../../../services/login.service';

@Component({
  selector: 'app-user-bar',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './user-bar.component.html',
  styleUrl: './user-bar.component.scss',
})
export class UserBarComponent {
  readonly login = inject(LoginService);
  readonly user = this.login.user;

  private router = inject(Router);

  // Na stronie głównej powrót do niej nie ma sensu — chowamy przycisk.
  readonly isHome = toSignal(
    this.router.events.pipe(
      filter((e): e is NavigationEnd => e instanceof NavigationEnd),
      map((e) => isHomeUrl(e.urlAfterRedirects)),
      startWith(isHomeUrl(this.router.url)),
    ),
    { initialValue: isHomeUrl(this.router.url) },
  );
}

/** `/`, ale też `/?a=1` i `/#kontakt` — landing z kotwicą do sekcji. */
function isHomeUrl(url: string): boolean {
  return url === '/' || url.startsWith('/?') || url.startsWith('/#');
}
